export const HOME = {
  emergentLink: 'home-emergent-link',
};

export const APP = {
  headerLogo: 'app-header-logo',
  headerTitle: 'app-header-title',
  tabsList: 'main-tabs-list',
  farmerSelect: 'farmer-select',
  registerFarmerBtn: 'register-farmer-btn',
  farmerDashboard: 'farmer-dashboard',
  farmMiniCard: 'farm-mini-card',
  openFarmBtn: 'open-farm-btn',
  addFarmFromDashboardBtn: 'add-farm-from-dashboard-btn',
  switchFarmerBtn: 'switch-farmer-btn',
  enableAlertsBtn: 'enable-alerts-btn',
  alertsEnabledChip: 'alerts-enabled-chip',
  pwaInstallBanner: 'pwa-install-banner',
  pwaInstallBtn: 'pwa-install-btn',
  chatbotPhotoBtn: 'chatbot-photo-btn',
  chatbotPhotoInput: 'chatbot-photo-input',
  chatbotBubbleImage: 'chatbot-bubble-image',
  farmerForm: {
    name: 'farmer-form-name-input',
    phone: 'farmer-form-phone-input',
    village: 'farmer-form-village-input',
    mandal: 'farmer-form-mandal-input',
    district: 'farmer-form-district-input',
    submit: 'farmer-form-submit',
    cancel: 'farmer-form-cancel',
  },
  farmSelect: 'farm-select',
  registerFarmBtn: 'register-farm-btn',
  farmForm: {
    name: 'farm-form-name-input',
    lat: 'farm-form-lat-input',
    lon: 'farm-form-lon-input',
    area: 'farm-form-area-input',
    soil: 'farm-form-soil-input',
    irrigation: 'farm-form-irrigation-select',
    submit: 'farm-form-submit',
    cancel: 'farm-form-cancel',
  },
  seasonYear: {
    year: 'season-year-input',
    season: 'season-select',
    irrigationAvailability: 'irrigation-availability-select',
    selectedCrop: 'selected-crop-select',
  },
  tabs: {
    plan: 'tab-plan',
    suitability: 'tab-suitability',
    sowing: 'tab-sowing',
    weather: 'tab-weather',
    irrigation: 'tab-irrigation',
    nutrient: 'tab-nutrient',
    growth: 'tab-growth',
    harvest: 'tab-harvest',
    market: 'tab-market',
    analytics: 'tab-analytics',
    schemes: 'tab-schemes',
  },
  actions: {
    runSuitability: 'run-suitability-btn',
    runDndc: 'run-dndc-btn',
    runSowingIsat: 'run-sowing-isat-btn',
    runSowingCalendar: 'run-sowing-calendar-btn',
    runWeather: 'run-weather-btn',
    runIrrigation: 'run-irrigation-btn',
    runNutrient: 'run-nutrient-btn',
    runGrowth: 'run-growth-btn',
    runHarvest: 'run-harvest-btn',
    runMarketMsp: 'run-market-msp-btn',
    runMarketMandi: 'run-market-mandi-btn',
    runMarketCompare: 'run-market-compare-btn',
    runAiAdvisor: 'run-ai-advisor-btn',
    runFinalPlan: 'run-final-plan-btn',
  },
  mandi: {
    commodity: 'mandi-commodity-input',
    vehicle: 'mandi-vehicle-select',
    quantity: 'mandi-quantity-input',
  },
};
